import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import DateFnsUtils from "@date-io/date-fns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Grid from "@mui/material/Grid";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import React from "react";

export default function MaterialUIPickers(props) {
  const { name, label, value, onChange } = props;

  const convertToDefEventPara = (name, value) => ({
    target: {
      name,
      value,
    },
  });

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} utils={DateFnsUtils}>
      <Grid container justifyContent="space-around">
        <DatePicker
          disableToolbar
          autoOk
          variant="inline"
          format="yyyy-MM-dd"
          margin="normal"
          id="date-picker-inline"
          label={label}
          name={name}
          value={value}
          openTo="year"
          disableFuture
          onChange={(date) =>
            onChange(
              convertToDefEventPara(
                name,
                new Date(date).toISOString().slice(0, 10)
              )
            )
          }
          slotProps={{
            actionBar: {
              actions: ['accept', 'cancel', 'today', 'clear'],
            },
            textField: {
              variant: 'outlined',
            },
          }}
          sx={{
            width: '100%',
            '& .MuiOutlinedInput-root': {
              '& fieldset': {
                borderColor: 'divider',
              },
              '&:hover fieldset': {
                borderColor: 'primary.main',
              },
              '&.Mui-focused fieldset': {
                borderColor: 'primary.main',
              },
            },
          }}
        />
      </Grid>
    </LocalizationProvider>
  );
}